export default __webpack_public_path__ + "static/media/PowerBI_Security_4.adc85948.png";